// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__MbTxY","logo":"Header_logo__3yB-7"};